// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"21":"12dfbfe8","453":"1e74286a","967":"b9b76842"}[chunkId] + ".chunk.js");